import { CategoryTreeObject } from "@vviinn/user-managment-client-ts";

const traverseCategoryTree = (
  categories: CategoryTreeObject,
  parentEntity: string,
  currentResults: string[],
) => {
  currentResults.push(parentEntity);
  for (const category of categories.tree) {
    traverseCategoryTree(
      category,
      parentEntity.length
        ? parentEntity + " > " + category.title
        : category.title,
      currentResults,
    );
  }
};

export const categoryToAutosuggestion = (
  categories?: CategoryTreeObject,
): string[] => {
  if (!categories || !categories.title) return [];
  const parentEntity = categories?.title === "root" ? "" : categories?.title;
  const result: string[] = [];
  traverseCategoryTree(categories, parentEntity, result);
  return result;
};
